module.exports = __webpack_public_path__ + "4932c8f8e70e949257a48da1ee024817.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/create_workshop_info/top_background@3x.jpg
// module id = 651
// module chunks = 0